import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  ButtonGroup,
  IconButton,

  MenuItem,

  Select,

  Switch,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
} from "@mui/material";



import { CircularProgress } from "@mui/material";
import ReplayIcon from "@mui/icons-material/Replay";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import FlagIcon from "@mui/icons-material/Flag";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import HistoryIcon from "@mui/icons-material/History";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import AddIcon from '@mui/icons-material/Add';
import RiskDecisionTable from "./RiskTable";



const guardrailRows = [
  {
    id: 1,
    date: "Mar 20, 2022 4:45 PM",
    decisionId: "12691992",
    module: "Rehabtronics",
    category: "Low Value",
    categoryType: "low",
    status: "Completed",
    statusType: "success",
  },
  {
    id: 2,
    date: "Feb 17, 2022 4:32 PM",
    decisionId: "155882",
    module: "StyleHub",
    category: "Flagged",
    categoryType: "flagged",
    status: "High Risk",
    statusType: "danger",
  },
  {
    id: 3,
    date: "Mar 8, 2022 4:33 PM",
    decisionId: "15582",
    module: "Good Grain",
    category: "Level 3 Auto-Approval",
    categoryType: "info",
    status: "92%",
    statusType: "progress",
  },
];



const activityData = [
  {
    title: "Admins Only template applied",
    time: "3 days ago",
    author: "Jams Doe",
    hasAction: true,
  },
  {
    title: "Moderate Guardrail Template activated",
    time: "5 days ago",
    author: "tekhad L.",
    hasAction: true,
  },
];

const actionList = [
  { label: "Repeat Log", icon: <HistoryIcon /> },
  { label: "View Full Log", icon: <HistoryIcon /> },
  { label: "Copy Decision ID", icon: <ContentCopyIcon /> },
  { label: "Contact Support", icon: <SupportAgentIcon /> },
];




function AIDecisions() {
  const navigate = useNavigate();
  const [tabIndex, setTabIndex] = useState(0);
  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setTabIndex(newValue);
  };


  const confidence = 83;

  // 🔁 DATA ARRAY
  const statsData = [
    {
      label: "Total Rollbacks",
      value: 8,
      icon: <ReplayIcon className="icon rollback" />,
    },
    {
      label: "High Risk Actions",
      value: 45,
      icon: <WarningAmberIcon className="icon risk" />,
    },
    {
      label: "Total Flags",
      value: 63,
      icon: <FlagIcon className="icon flag" />,
    },
  ];


  const [category, setCategory] = React.useState("");
  const [range, setRange] = React.useState("");



  return (
    <>
      {/* ================= PAGE TITLE ================= */}
      <div className="main_title ai_command_page d_flex">
        <div className="lt">
          <h1>AI Decisions, Logs & Explainability</h1>
          <p>
            <button onClick={() => navigate("/dashboard")}>Dashboard</button> -
            Controls & AI Behaviour Management
          </p>
        </div>
        <div className="right_s">
          <ButtonGroup aria-label="Basic button group" variant="contained">
            <Button className="auto_pilot" color="primary">
              <AddIcon /> Smart Defaults
            </Button>
            <Button className="off on">ON</Button>
            <Button color="error">Emergency stop</Button>
          </ButtonGroup>
        </div>
      </div>

      <Box className="custom_tabs1 mt_20">
        <Tabs
          value={tabIndex}
          onChange={handleTabChange}
          className="custom_tabs_links"
        >
          <Tab label="Timeline" />
          <Tab label="Risks" />
          {/* <Tab label="Rollbacks" />
          <Tab label="Metrics" /> */}

        </Tabs>
      </Box>
      <div className="table_flex mt_20">
        {tabIndex === 0 && (
          <div className="lt">
            <TableContainer className="table_container guardrail_table">
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Sr. No.</TableCell>
                    <TableCell>Date & Time | Decision</TableCell>
                    <TableCell>Decision ID</TableCell>
                    <TableCell>Module</TableCell>
                    <TableCell>Vendor / Category</TableCell>
                    <TableCell>Automated Decision</TableCell>
                    <TableCell>Actions</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {guardrailRows.map((row, index) => (
                    <TableRow key={row.id} hover>
                      <TableCell>{index + 1}.</TableCell>

                      {/* DATE */}
                      <TableCell>
                        <p className="date_text">{row.date}</p>
                      </TableCell>

                      {/* DECISION ID */}
                      <TableCell>
                        <span className="tag decision_id">
                          👁 {row.decisionId}
                        </span>
                      </TableCell>

                      {/* MODULE */}
                      <TableCell>
                        <p className="module_name">{row.module}</p>
                      </TableCell>

                      {/* CATEGORY */}
                      <TableCell>
                        <span className={`tag category ${row.categoryType}`}>
                          {row.category}
                        </span>
                      </TableCell>

                      {/* STATUS */}
                      <TableCell>
                        <span className={`tag status ${row.statusType}`}>
                          {row.status}
                        </span>
                      </TableCell>

                      {/* ACTIONS */}
                      <TableCell>
                        <span className="tag action">
                          👁 Explain
                        </span>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>

        )}

        {tabIndex === 1 &&
          <RiskDecisionTable />
        }

        {tabIndex === 2 &&
          // <PermissionLogTable />
          <span>fdfdhj</span>
        }

        {tabIndex === 3 &&
          // <TemplateTable />
          <p>fd</p>
        }

        <div className="rt ai_decision_right">
          <div className="right_panel">
            <div className="maturity_card">
              <h3 className="card_title">AI Decision Insights</h3>

              {/* Confidence */}
              <div className="confidence_section">
                <div className="progress_wrapper">
                  <CircularProgress
                    variant="determinate"
                    value={confidence}
                    size={60}
                    thickness={5}
                    className="progress_circle"
                  />
                  <p className="progress_value">{confidence}</p>
                </div>

                <div className="confidence_text">
                  <p className="label">Avg Confidence Level</p>
                  <p className="sub_label">Across decisions</p>
                </div>
              </div>

              {/* 🔁 LOOPED STATS */}
              <div className="stats_list">
                {statsData.map((item, index) => (
                  <div className="stat_row" key={index}>
                    <div className="stat_left">
                      {item.icon}
                      <p>{item.label}</p>
                    </div>
                    <p className="stat_value">{item.value}</p>
                  </div>
                ))}
              </div>
            </div>


            <div className="maturity_card">

              {/* Header */}
              <div className="card_header mb_20">
                <h3>AI Decision Insights</h3>
                <MoreHorizIcon className="menu_icon" />
              </div>

              {/* Filters */}
              <div className="filter_form gap_m form">
                <div className="control_group w_50">
                  <Select
                    value={category}
                    displayEmpty
                    hiddenLabel
                    onChange={(e) => setCategory(e.target.value)}
                    renderValue={(selected) =>
                      selected === "" ? "Select Category" : selected
                    }
                  >
                    <MenuItem value="">
                      <em>All</em>
                    </MenuItem>
                    <MenuItem value="admin">Admin</MenuItem>
                    <MenuItem value="guardrail">Guardrail</MenuItem>
                  </Select>
                </div>

                <div className="control_group w_50">
                  <Select
                    value={range}
                    displayEmpty
                    hiddenLabel
                    onChange={(e) => setRange(e.target.value)}
                    renderValue={(selected) =>
                      selected === "" ? "Select Date Range" : selected
                    }
                  >
                    <MenuItem value="7">Last 7 Days</MenuItem>
                    <MenuItem value="15">Last 15 Days</MenuItem>
                    <MenuItem value="30">Last Month</MenuItem>
                  </Select>
                </div>
              </div>

              {/* Activity List */}
              <div className="activity_list">
                {activityData.map((item, index) => (
                  <div className="activity_item" key={index}>
                    <div className="activity_text">
                      <p className="title">{item.title}</p>
                      <p className="meta">
                        {item.time} &nbsp; {item.author}
                      </p>
                    </div>

                    {item.hasAction && (
                      <MoreHorizIcon className="row_action" />
                    )}
                  </div>
                ))}
              </div>

              {/* Footer Link */}
              <p className="more_details">More Details</p>

              {/* Action Menu */}
              <div className="action_menu">
                {actionList.map((item, index) => (
                  <div className="action_item" key={index}>
                    {item.icon}
                    <p>{item.label}</p>
                  </div>
                ))}
              </div>

            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AIDecisions;
